
import { Bank, BankType } from "@/models/base";
import { BankService } from "@/services/bank-service";
import Vue from "vue";
import { IDataTableColumn, DataTableCompareFunction } from "winfakt-vue-components";
import AppBankEditDefault from "./BankEditDefault.vue";
import AppCodaSplitRows from "./CodaSplitRows.vue";
import AppCodaSplitModal from "./CodaSplitModal.vue";
import {dom} from "@fortawesome/fontawesome-svg-core";
import { i18n } from "@/setup/i18n-setup";
import { printHumanFloat } from "@/utils/pretty-print";

export default Vue.extend({
	data(){
		return {
			selectedItems: [] as Bank[],
			toEditBank: null as null | Bank,
			editedBankIndex: -1,
			splitRows: false,
			bankTypes: [] as BankType[],
			uploading: false
		};
	},
	props: {
		items: {
			type: Array as ()=>Bank[],
			required: true
		},
		customSave: {
			type: Function as unknown as ()=>((items: Bank[]) => Promise<void>),
			default: null
		}
	},
	computed: {
		// eslint-disable-next-line max-lines-per-function
		columns():IDataTableColumn[]{
			let result = ([
				{
					name: "",
					property: "codaRowIcon",
					width: "20px",
					print(value:string):string{
						if (value){
							return "<i class='"+value+"'/>";
						}
						return "";
					}
				},
				{
					name: this.$ct("models.friendlyNames.BankType.Name").toString(),
					property: "Type.Name",
					width: "120px"
				},
				{
					name: this.$ct("models.friendlyNames.Bank.FriendlySaleID").toString(),
					property: "saleOrPurchase",
					width: "115px",
				},
				{
					name: this.$ct("models.friendlyNames.Bank.StNr").toString(),
					property: "StNr",
					width: "80px"
				},
				{
					name: this.$ct("models.friendlyNames.Bank.Kind").toString(),
					property: "Kind",
					width: "60px",
					print(value:number):string{
						if (value == 3){
							return i18n.t("components.bank.bank-kinds.purchase").toString();
						}
						if (value == 2){
							return i18n.t("components.bank.bank-kinds.sale").toString();
						}
						return i18n.t("components.bank.bank-kinds.diverse").toString();
					}
				},
				{
					name: this.$ct("models.friendlyNames.Bank.LedgerAccountCode").toString(),
					property: "LedgerAccountCode",
					width: "50px",
					center: true
				},
				{
					name: this.$ct("models.friendlyNames.ContactAddress.Name").toString(),
					property: "Contact.MainAddress.CompanyOrFullName",
					width: "150px",
					center: true
				},
				{
					name: this.$ct("components.bank.labels.InvoiceAmount").toString(),
					property: "saleOrPurchaseTotal",
					Bwidth: "75px",
					right: true,
					print(value:number):string{
						return printHumanFloat(value);
					}
				},
				{
					name: this.$ct("models.friendlyNames.Sale.TotalOpen").toString(),
					property: "saleOrPurchaseTotalOpen",
					Bwidth: "75px",
					right: true,
					print(value:number):string{
						return printHumanFloat(value);
					}
				},
				{
					name: this.$ct("components.bank.labels.PayedAmount").toString(),
					property: "Total",
					Bwidth: "80px",
					right: true,
					print(value:number):string{
						return printHumanFloat(value);
					}
				},
				{
					name: this.$ct("models.friendlyNames.Bank.Info").toString(),
					property: "Info",
					width: "2400px",
				}
			] as IDataTableColumn[]).map((c:IDataTableColumn)=>{
				c.disableSorting = true;
				return c;
			});
			return result;
		},
		compare():DataTableCompareFunction{
			return (a:Bank, b:Bank)=>{
				return  a==b;
			};
		},
		firstSelectedBank():Bank{
			return this.selectedItems[0];
		}
	},
	methods: {
		async insertCheckmarks(){
			await this.$nextTick();
			await dom.i2svg();
		},
		async save(){
			try{
				this.uploading = true;
				if (this.customSave) {
					await this.customSave(this.items);
				} else {
					await BankService.batchPostBooking(this.items);
				}
				this.$emit("done");
			}catch(err){
			}finally{
				this.uploading = false;
			}
		},
		cancel(){
			this.$emit("close");
		},
		edit(){
			let bank = this.selectedItems[0];
			if (!bank) return;
			this.editedBankIndex = this.items.indexOf(bank);
			this.toEditBank = new Bank(bank.getJSON());
		},
		cancelEdit(){
			this.editedBankIndex = -1;
			this.toEditBank = null;
		},
		applyEdit(){
			if (!this.toEditBank) return;
			this.items[this.editedBankIndex] = this.toEditBank;
			this.selectedItems = [];
			this.toEditBank = null;
			this.editedBankIndex = -1;
		},
		remove(){
			for (let item of this.selectedItems){
				let i = this.items.indexOf(item);
				this.items.splice(i,1);
			}
			this.selectedItems = [];
		},
		splitRecords(records:Bank[]){
			let i = this.items.indexOf(this.selectedItems[0]);
			this.items.splice(i, 1, ...records);
			this.selectedItems = [];
			this.splitRows = false;
		},
		split(records:number){
			let i = this.items.indexOf(this.selectedItems[0]);
			for(let x=0;x<records;x++){
				let b = new Bank(this.selectedItems[0].getJSON());
				b.TotalDC = 0;
				this.items.splice(i, 0, b);
			}
			this.items.splice(i,1);
			this.selectedItems = [];
			this.splitRows = false;
		}
	},

	updated(){
		this.insertCheckmarks();
	},
	async mounted(){
		this.bankTypes = await BankService.getTypes();
		await this.insertCheckmarks();
	},
	components: {
		AppBankEditDefault,
		AppCodaSplitRows,
		AppCodaSplitModal
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
